// extracted by mini-css-extract-plugin
module.exports = {"eventNotStarted":"_2VSVe__eventNotStarted","eventDescriptionWrapper":"_fev-__eventDescriptionWrapper"};